import { formatRut } from 'react-rut-formatter';
import fetcher from '../../utils/fetcher';

export async function postDataDeletionRequest(rut: string, recaptchaValue: string | undefined) {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/client/data-deletion/request`,
    'POST',
    { rut: formatRut(rut).toLowerCase(), captchaToken: recaptchaValue },
    null,
  );
}

export async function postDataDeletionConfirm(token: string) {
  return fetcher(
    `${process.env.REACT_APP_API_URL}/client/data-deletion/confirm`,
    'POST',
    null,
    token,
  );
}
